import { type ChangeEvent, createContext, type FC, type MouseEvent, type ReactElement, useState } from 'react';
import { usePagination } from '../content/hooks';
import type { ListTechnicalSupportProviderModel, Order, TechnicalSupportProviderSortingFields } from '../models';

interface ITechnicalSupportProvidersContext {
  technicalSupportProvidersUpdate: boolean;
  toggleTechnicalSupportProvidersUpdate: () => void;
  technicalSupportProviders: ListTechnicalSupportProviderModel[];
  setTechnicalSupportProviders: (val: ListTechnicalSupportProviderModel[]) => void;
  page: number;
  setPage: (val: number) => void;
  limit: number;
  setLimit: (val: number) => void;
  count: number;
  setCount: (val: number) => void;
  order: Order;
  setOrder: (val: Order) => void;
  orderBy: TechnicalSupportProviderSortingFields;
  setOrderBy: (val: TechnicalSupportProviderSortingFields) => void;
  handlePageChange: (_event: any, newPage: number) => void;
  handleLimitChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleRequestSort: (_event: MouseEvent, property: TechnicalSupportProviderSortingFields) => void;
  loading: boolean;
  setLoading: (val: boolean) => void;
}

export const TechnicalSupportProvidersContext = createContext<ITechnicalSupportProvidersContext>(
  {} as ITechnicalSupportProvidersContext
);

export const TechnicalSupportProvidersProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const [technicalSupportProvidersUpdate, setTechnicalSupportProvidersUpdate] = useState(false);
  const toggleTechnicalSupportProviderUpdate = (): void =>
    setTechnicalSupportProvidersUpdate(!technicalSupportProvidersUpdate);

  const {
    page,
    setPage,
    limit,
    setLimit,
    count,
    setCount,
    order,
    setOrder,
    orderBy,
    setOrderBy,
    handlePageChange,
    handleLimitChange,
    handleRequestSort
  } = usePagination<TechnicalSupportProviderSortingFields>(toggleTechnicalSupportProviderUpdate, 'name', 'desc');

  const [technicalSupportProviders, setTechnicalSupportProviders] = useState<ListTechnicalSupportProviderModel[]>([]);
  const [loading, setLoading] = useState(false);

  return (
    <TechnicalSupportProvidersContext.Provider
      value={{
        technicalSupportProvidersUpdate,
        toggleTechnicalSupportProvidersUpdate: toggleTechnicalSupportProviderUpdate,
        technicalSupportProviders,
        setTechnicalSupportProviders,
        page,
        setPage,
        limit,
        setLimit,
        count,
        setCount,
        order,
        setOrder,
        orderBy,
        setOrderBy,
        handlePageChange,
        handleLimitChange,
        handleRequestSort,
        loading,
        setLoading
      }}
    >
      {children}
    </TechnicalSupportProvidersContext.Provider>
  );
};
